/*
 * $Id:: saga.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all } from 'redux-saga/effects';

import {
    registerAccount,
    requestForgotPassword,
    requestResetPassword,
    requestValidateToken,
    sendNewVerificationCode,
    validateCredentials,
    verifyAccount,
    getUserInfo,
} from '../pages/AuthenticatedPage/model';
import { getUsers, userImpersonation } from '../pages/ImpersonateUserPage/model';
import {
    createChildAccount,
    getAccountDetails,
    updateLanguage,
    changePassword,
    updateAccountDetails,
    getChildAccounts,
    deactivateChildAccount,
    editChildAccount,
    activateChildAccount,
    confirmDeactivateParentAccount,
    deactivateParentAccount,
} from '../pages/MyAccountPage/model';
import { getMyApplications, getApplicationReceipt, getMyApplicationsExport, getImage } from '../pages/MyApplicationsPage/model';
import { getDraftApplications, deleteDraftApplication, getMyDraftsExport, resumeDraftApplication } from '../pages/MyDraftsPage/model';
import { getOnlineServices, updateFavoriteOnlineServices } from '../pages/OnlineServicesPage/model';
import { login, logout, requestLogoutRedirect } from '../pages/SSOPage/model';
import { fetchLiterals, fetchCountries, fetchGlobals } from './appModel';
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        activateChildAccount(),
        changePassword(),
        confirmDeactivateParentAccount(),
        createChildAccount(),
        deactivateChildAccount(),
        deactivateParentAccount(),
        editChildAccount(),
        getAccountDetails(),
        getChildAccounts(),
        getUserInfo(),
        fetchCountries(),
        fetchGlobals(),
        fetchLiterals(),
        login(),
        logout(),
        requestForgotPassword(),
        registerAccount(),
        requestLogoutRedirect(),
        requestResetPassword(),
        requestValidateToken(),
        sendNewVerificationCode(),
        updateAccountDetails(),
        updateLanguage(),
        validateCredentials(),
        verifyAccount(),
        getMyApplications(),
        getImage(),
        getApplicationReceipt(),
        getMyApplicationsExport(),
        getDraftApplications(),
        getOnlineServices(),
        updateFavoriteOnlineServices(),
        deleteDraftApplication(),
        resumeDraftApplication(),
        getMyDraftsExport(),
        getUsers(),
        userImpersonation(),
    ]);
}
